import React from "react";
import { useForm } from "react-hook-form";

export function EmptyMember(props) {
    const { register, handleSubmit, reset } = useForm();

    const onSubmit = (data) => {
        if (!data.nickName.trim()) return;

        const member = {
            nickName: data.nickName
        };

        if (props.onCreateClicked) {
            props.onCreateClicked(member);
            reset();
        }
    }

    return (
        <div style={{ marginBottom: '20px', width: '350px' }}>
            <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', gap: '8px' }}>
                <input
                    {...register('nickName')}
                    placeholder="Нікнейм учасника..."
                    style={{
                        flex: 1,
                        padding: '10px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        outline: 'none'
                    }}
                />
                <button type="submit" style={{
                    backgroundColor: '#4f46e5',
                    color: 'white',
                    border: 'none',
                    padding: '10px 20px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: '600',
                    transition: '0.2s'
                }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#74baf6'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#4f46e5'}
                >
                    Додати
                </button>
            </form>
        </div>
    );
}